import { createAction } from 'redux-actions';

import { ADVENTURES_FILTER_SET, ADVENTURES_FILTER_UPDATE, ADVENTURES_FILTER_CLEAR } from './types';

export const updateAdventuresFilter = createAction(ADVENTURES_FILTER_UPDATE);

export const setAdventuresFilter = createAction(ADVENTURES_FILTER_SET);

export const clearAdventuresFilter = createAction(ADVENTURES_FILTER_CLEAR);
